import { ReportSubtype } from '../models/Report';

export const reportSubtypeToString = (reportSubtype: ReportSubtype, miamiBrand?: boolean): { title: string } => {
  switch (reportSubtype) {
    case ReportSubtype.DIAGNOSTIC_SUMMARY:
      return { title: 'Diagnostic Skill Performance By Class' };
    case ReportSubtype.DIAGNOSTIC_STUDENTS_UNFINISHED_DIAGNOSTIC:
      return { title: 'Student Diagnostic Details' };
    case ReportSubtype.PROGRESS_DETAILED_SKILL_REPORT:
      return { title: 'Detailed Skill' };
    case ReportSubtype.PROGRESS_SKILL_ASSESSMENT_HISTORY:
      return { title: miamiBrand ? 'Skill Challenge History' : 'Skill Assessment History' };
    default:
      return { title: '' };
  }
};
